module.exports = __webpack_public_path__ + "img/icon-api.db3d8906.svg";